module.exports = __webpack_public_path__ + "img/notification-bell.9ac73074.svg";